<!--
 * @Description:导入结算金额
 * @Date: 2023/4/20 下午3:41:37
-->
<template>
  <base-dialog
    width="436px"
    :visible="true"
    :model-value="true"
    :show-close="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
    title="导入金额"
  >
    <div style="padding: 20px">
      <p style="color: var(--xrk-color-primary)">
        注：下载的列表数据除终端结算金额外其他内容请勿修改，否则会上传失败
      </p>
      <BaseUpload
        v-model:fileList="formData.fileList"
        style="width: 400px"
        ref="upload"
        listType="text"
        :limit="1"
        :limit-size="20"
        :accept="['xls', 'xlsx']"
        :httpRequest="httpRequest"
        :auto-upload="false"
        :onError="onError"
        btnText="请选择文件"
      >
        <template #tip>
          <p style="line-height: 20px; margin-top: 15px">
            只能上传xls或xlsx文件,最大支持20M
          </p>
        </template>
      </BaseUpload>
    </div>

    <BaseButton
      style="margin-left: 20px"
      type="text"
      :icon="Download"
      @click="downLoadTempLate"
    >
      下载列表数据
    </BaseButton>
    <template #footer>
      <BaseButton @click="onCancel" type="default">取消</BaseButton>
      <BaseButton :click="onConfirm" type="primary">确认导入</BaseButton>
    </template>
  </base-dialog>
</template>
<script lang="tsx" setup>
import {
  defineProps,
  withDefaults,
  reactive,
  ref,
  computed,
  defineEmits
} from 'vue';
import { BaseButton, BaseDialog, BaseUpload, XrkMessage } from 'xrk-components';
import { Download } from '@element-plus/icons-vue';
import { importSettlementAmountAjax } from '../data-source/apis';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';

const store = useProjectDetailStore();

const props = withDefaults(
  defineProps<{
    remove?: () => {};
  }>(),
  {
    remove() {
      return () => ({});
    }
  }
);
const emits = defineEmits(['downLoadTaskList', 'refreshTabel']);

const projectInfo = computed(() => store.baseData.projectInfo);

const upload = ref(null);

const formData = reactive({
  fileList: []
});
const onCancel = () => {
  props.remove();
};

const onConfirm = async () => {
  if (formData.fileList.length <= 0) {
    XrkMessage.error('请先上传文件！');
    return;
  }
  await upload.value.submit();
  XrkMessage.success('导入成功');
  emits('refreshTabel');
  onCancel();
};
const httpRequest = ({ file }) => {
  return importSettlementAmountAjax({ file, projectId: projectInfo.value.id });
};
const onError = errorInfo => {
  XrkMessage.error(errorInfo.msg);
};
//列表下载
function downLoadTempLate() {
  emits('downLoadTaskList');
}
</script>
